import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import SectionButton from "../components/SectionButton";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 700,
    color: "#114668",
    alignSelf: "center",
  },
  sectionButtonBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px 12px 24px",
    border: "3px solid #efeff2",
    borderRadius: 10,
  },
  buttonText: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 700,
    color: "#114668",
    marginLeft: "8px",
  },
  box: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px 12px 24px",
    flexDirection: "column",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  textLight: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "start",
    marginRight: "10px",
  },
}));

const section = (index, classes, title, image, onClick, eklok, disabled) => (
  <Grid item xs={6} key={index}>
    <Box className={classes.sectionButtonBox}>
      <SectionButton
        title={title}
        image={image}
        onClick={() => onClick(eklok)}
        disabled={disabled}
      />
    </Box>
  </Grid>
);

const MobileFrameHomeView = ({ sections, eklokData }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <Box className={classes.box}>
        <Box className={classes.horizontalBox}>
          <Typography className={classes.textLight}>
            {t("mobile_frame.home.eklok_name")}
          </Typography>
          <Typography className={classes.title}>{eklokData.name}</Typography>
        </Box>
        <Box
          className={classes.button}
          onClick={() => {
            history.push("/app/event/list/" + eklokData.id);
          }}
        >
          <Typography className={classes.buttonText}>
            {t("mobile_frame.home.view_all_event").toUpperCase()}
          </Typography>
        </Box>
      </Box>
      <Grid container rowspacing={3} columnspacing={{ xs: 1, sm: 2, md: 3 }}>
        {Object.keys(sections).map((sectionName, index) => {
          const item = sections[sectionName];
          return section(
            index,
            classes,
            item.title,
            item.image,
            item.onClick,
            eklokData.id,
            item.disabled,
          );
        })}
      </Grid>
    </>
  );
};

export default MobileFrameHomeView;
